/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import axios from "axios";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";

import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import MDBadge from "admin/components/MDBadge";

import DashboardLayout from "admin/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "admin/examples/Navbars/DashboardNavbar";
import DataTable from "admin/examples/Tables/DataTable";

const API = process.env.REACT_APP_APIHOST || "http://localhost:3033";
const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—";

function Stat({ label, value, color }) {
  return (
    <Card>
      <MDBox p={2} textAlign="center">
        <MDTypography variant="h4" fontWeight="bold" color={color || "text"}>{value}</MDTypography>
        <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>{label}</MDTypography>
      </MDBox>
    </Card>
  );
}

function TelegramSubscribers() {
  const [rows, setRows] = useState([]);
  const [counts, setCounts] = useState({ total: 0, platform: 0, telegramOnly: 0, active: 0 });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/free-trial/subscribers`);
      if (res.data.status) {
        setRows(res.data.data || []);
        setCounts(res.data.counts || {});
      }
    } catch (e) {
      console.error("subscribers", e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const columns = [
    { Header: "name", accessor: "name", align: "left" },
    { Header: "telegram", accessor: "contact", align: "left" },
    { Header: "type", accessor: "source", align: "center" },
    { Header: "countries", accessor: "countries", align: "left" },
    { Header: "trial ends", accessor: "trialEnds", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "email", accessor: "email", align: "left" },
  ];

  const tableRows = rows.map((r) => ({
    name: (
      <MDTypography variant="caption" color="text" fontWeight="medium">{r.name || "—"}</MDTypography>
    ),
    contact: (
      <MDBox display="flex" flexDirection="column">
        {r.username ? <MDTypography variant="caption" color="text" fontWeight="medium">@{r.username}</MDTypography> : null}
        {r.phone ? <MDTypography variant="caption" color="text">{r.phone}</MDTypography> : null}
        {!r.username && !r.phone ? <MDTypography variant="caption" color="text">—</MDTypography> : null}
      </MDBox>
    ),
    source: (
      <MDBadge
        badgeContent={r.source}
        color={r.source === "Telegram only" ? "info" : (r.source === "Platform trial" ? "warning" : "success")}
        variant="gradient"
        size="sm"
      />
    ),
    countries: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {(r.countries || []).length
          ? ((r.countries.length > 4 ? `${r.countries.slice(0, 4).join(", ")} +${r.countries.length - 4}` : r.countries.join(", ")))
          : "—"}
      </MDTypography>
    ),
    trialEnds: (
      <MDTypography variant="caption" color="text" fontWeight="medium">{fmtDate(r.trialEnds)}</MDTypography>
    ),
    status: (
      <MDBadge
        badgeContent={r.active ? "active" : "expired"}
        color={r.active ? "success" : "error"}
        variant="gradient"
        size="sm"
      />
    ),
    email: (
      <MDTypography variant="caption" color="text">{r.email || "—"}</MDTypography>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <MDTypography variant="h4" fontWeight="medium">Telegram subscribers</MDTypography>
          <MDBox display="flex" alignItems="center" sx={{ cursor: "pointer", opacity: 0.7 }} onClick={load}>
            <Icon>refresh</Icon>
          </MDBox>
        </MDBox>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={6} md={3}><Stat label="Total subscribers" value={counts.total ?? 0} /></Grid>
          <Grid item xs={6} md={3}><Stat label="Active" value={counts.active ?? 0} color="success" /></Grid>
          <Grid item xs={6} md={3}><Stat label="Platform trials" value={counts.platform ?? 0} color="warning" /></Grid>
          <Grid item xs={6} md={3}><Stat label="Telegram only" value={counts.telegramOnly ?? 0} color="info" /></Grid>
        </Grid>

        <Card>
          <MDBox p={2}>
            {loading ? (
              <MDBox display="flex" justifyContent="center" py={5}><CircularProgress color="info" /></MDBox>
            ) : rows.length === 0 ? (
              <MDBox py={5} textAlign="center"><MDTypography variant="button" color="text">No Telegram subscribers yet.</MDTypography></MDBox>
            ) : (
              <DataTable
                table={{ columns, rows: tableRows }}
                isSorted={false}
                entriesPerPage={{ defaultValue: 25, entries: [10, 25, 50, 100] }}
                showTotalEntries
                noEndBorder
              />
            )}
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default TelegramSubscribers;
